<div class="ask-polaris-button" (click)="onButtonClick()">
    <div class="speech-bubble">
        <span class="tooltip-text">{{ tooltip }}</span>
    </div>
    <app-polaris-icon class="polaris-icon"></app-polaris-icon>
</div>
